import Request from '~/providers/Request';

export const fetchFatherCorporations = async (input, page, resolve) => {
  await Request.get(`/admin/corporation?sort=name&direction=asc&qs=${input}&page=${page}&onlyFathers=true`).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.id} - ${e.name}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};
